jQuery(function($) {

  // Desktop Gallery
  galleryAdvance = function(gallery, move) {
    if(move == undefined) { move = 1; }

    numItems  = $(gallery).children().length;
    scrollVal = $(gallery).innerHeight();

    if(gallery.scrollPos == undefined) { gallery.scrollPos = 0; }

    gallery.scrollPos += move;

    if(gallery.scrollPos < 0) { gallery.scrollPos = (numItems-1)}
      if(gallery.scrollPos >= numItems) { gallery.scrollPos = 0; }

    $(gallery).children().animate({"top": (-1*gallery.scrollPos*scrollVal)+'px'});
  };

  randomTimeout = function() { return Math.floor(Math.random()*250); }

  $('.gallery--next').click(function() {
    $('.gallery__desktop').each(function(idx, gallery) {
      setTimeout(
        function() { galleryAdvance(gallery, 1); },
        randomTimeout()
        );
    });
  });

  $('.gallery--prev').click(function() {
    $('.gallery__desktop').each(function(idx, gallery) {
      setTimeout(
        function() { galleryAdvance(gallery, -1); },
        randomTimeout()
        );
    });
  });


  // Mobile Gallery
  $('.gallery__desktop').each(function(idx, gallery) {
    $(gallery).children().clone().appendTo($('.gallery__wrap--mobile'));
  });

  $('.gallery__wrap--mobile').flickity({
    imagesLoaded: true,
    pageDots: false,
    contain: true
  });

});